module.exports = __webpack_public_path__ + "assets/img/zzsl3.3b4d9d61.png";